/**
 * Управление виджетом reCAPTCHA вне компонента.
 *
 * Вынесено из файла компонента: React ожидает, что модуль с компонентом
 * экспортирует только компоненты, иначе перестаёт работать горячая перезагрузка.
 */

interface ReCaptchaGlobal {
  reset: (widgetId?: number) => void;
}

/**
 * Сбрасывает пройденную проверку.
 *
 * Нужен после отказа сервера: токен одноразовый, и повторная отправка формы
 * со старым токеном снова не пройдёт.
 */
export function resetCaptcha(): void {
  const grecaptcha = (window as { grecaptcha?: ReCaptchaGlobal }).grecaptcha;
  grecaptcha?.reset();
}
